// Future accreditation band (MCS certification mark & number, certification body,
// technology scope, consumer code / RECC, TrustMark). Set enabled=true and fill
// items with verified details to activate — no layout changes required.
export const ACCREDITATIONS = {
    enabled: false,
    items: [
        // { name: "MCS", number: "", body: "", scope: "Air Source Heat Pumps", logo: "" },
    ],
};

export const Accreditations = () => {
    if (!ACCREDITATIONS.enabled || ACCREDITATIONS.items.length === 0) return null;
    return (
        <section data-testid="accreditations-band" className="border-t border-slate-200 bg-slate-50 py-8">
            <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-8 px-4 sm:px-6 lg:px-8">
                {ACCREDITATIONS.items.map((item) => (
                    <div key={item.name} className="flex items-center gap-3">
                        {item.logo && <img src={item.logo} alt={`${item.name} accreditation`} className="h-10 w-auto" />}
                        <div className="text-xs text-slate-500">
                            <p className="font-semibold text-slate-700">{item.name}</p>
                            {item.number && <p>Certification No. {item.number}</p>}
                            {item.body && <p>{item.body}</p>}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};
